import { useCallback, useReducer } from 'react';
import isEmpty from 'lodash/isEmpty';
import { validationActionTypes } from '../constants';
import pick from 'lodash/pick';

const stripPayload = (value) => value.replace('&nbsp;', '').trim();

export const validationsReducer = (state, { type, payload }) => {
  switch (type) {
    case validationActionTypes.hasName:
      return { ...state, hasName: Boolean(payload && stripPayload(payload)) };

    case validationActionTypes.hasStimulus:
      return {
        ...state,
        hasStimulus: Boolean(payload && stripPayload(payload)),
      };

    case validationActionTypes.hasAllOptionsFilled:
      return {
        ...state,
        hasAllOptionsFilled:
          payload &&
          payload.every((option) => Boolean(stripPayload(option.label))),
      };

    case validationActionTypes.hasOneCorrectOptionSelected:
      return {
        ...state,
        hasOneCorrectOptionSelected: !isEmpty(
          payload && payload.valid_response.value,
        ),
      };

    case validationActionTypes.hasQuestion:
      return {
        ...state,
        hasQuestion: payload,
      };

    case validationActionTypes.hasAllRequiredTagsSelected:
      return { ...state, hasAllRequiredTagsSelected: payload };

    case validationActionTypes.hasTagSelected:
      return { ...state, hasTagSelected: payload };

    case validationActionTypes.scoringSectionErrors:
      return {
        ...state,
        scoringSectionErrors: payload && payload.errors.length,
        hasScoringSectionErrors:
          payload &&
          payload.errors.length !== state.initialScoringSectionErrors,
      };

    case validationActionTypes.clear:
      return {
        ...state,
        ...{
          hasName: false,
          hasStimulus: false,
          hasAllOptionsFilled: false,
          hasOneCorrectOptionSelected: false,
          hasAllRequiredTagsSelected: false,
          hasTagSelected: false,
          scoringSectionErrors: 4,
          initialScoringSectionErrors: 4,
          hasScoringSectionErrors: false,
          hasQuestion: false,
        },
      };

    default:
      return state;
  }
};

export default function useValidations() {
  const [validations, dispatchValidation] = useReducer(validationsReducer, {
    hasName: false,
    hasStimulus: false,
    hasAllOptionsFilled: false,
    hasOneCorrectOptionSelected: false,
    hasAllRequiredTagsSelected: false,
    hasTagSelected: false,
    scoringSectionErrors: 4,
    initialScoringSectionErrors: 4,
    hasScoringSectionErrors: false,
    hasQuestion: false,
  });

  const mcqValidationErrors = useCallback(() => {
    const mcqValidations = Object.values(
      pick(validations, [
        validationActionTypes.hasStimulus,
        validationActionTypes.hasAllOptionsFilled,
        validationActionTypes.hasOneCorrectOptionSelected,
        validationActionTypes.hasAllRequiredTagsSelected,
      ]),
    );

    return mcqValidations.filter((validation) => !validation).length;
  }, [validations]);

  const frqValidationErrors = useCallback(() => {
    const frqValidations = Object.values(
      pick(validations, [
        validationActionTypes.hasAllRequiredTagsSelected,
        validationActionTypes.hasQuestion,
      ]),
    );

    return frqValidations.filter((validation) => !validation).length;
  }, [validations]);

  return [
    validations,
    dispatchValidation,
    mcqValidationErrors,
    frqValidationErrors,
  ];
}
